import { Controller } from '@hotwired/stimulus'
import { stimulus } from '~/init'

export default class FileUploadController extends Controller {
  static targets = ['input', 'label', 'filename']

  select () {
    const file = this.inputTarget.files[0]
    if (file) {
      this.filenameTarget.textContent = file.name
      this.labelTarget.classList.add('border-primary', 'bg-primary/4')
      this.labelTarget.classList.remove('border-black/15')
    }
  }

  dragover (event) {
    event.preventDefault()
    this.labelTarget.classList.add('border-primary', 'bg-primary/4')
    this.labelTarget.classList.remove('border-black/15')
  }

  dragleave () {
    if (!this.inputTarget.files[0]) {
      this.labelTarget.classList.remove('border-primary', 'bg-primary/4')
      this.labelTarget.classList.add('border-black/15')
    }
  }

  drop (event) {
    event.preventDefault()
    const file = event.dataTransfer.files[0]
    if (file) {
      this.inputTarget.files = event.dataTransfer.files
      this.filenameTarget.textContent = file.name
    }
  }
}

stimulus.register('file-upload', FileUploadController)
